import { StepFormLayout } from 'lease-signing-flow-v2/components/step-form-layout/step-form-layout';
import { TermsAndConditions } from 'lease-signing-flow-v2/components/terms-and-conditions/terms-and-conditions';
import { WalletFeatureCarousel } from 'lease-signing-flow-v2/components/wallet-feature-carousel/wallet-feature-carousel';
import { LEASE_SIGNING_FLOW_STRINGS } from 'lease-signing-flow-v2/constants/strings';

const initialValues = {};

type Props = {
  currentStep: any;
  onSubmit: (values?: any) => void;
  steps: any;
};

export const WalletStep = ({ currentStep, onSubmit, steps }: Props) => (
  <StepFormLayout
    currentStep={currentStep}
    initialValues={initialValues}
    onSubmit={onSubmit}
    steps={steps}
    subTitle={LEASE_SIGNING_FLOW_STRINGS['wallet.subtitle']}
    title={LEASE_SIGNING_FLOW_STRINGS['wallet.title']}
    getForm={() => <WalletFeatureCarousel />}
    previousContent={<TermsAndConditions />}
  />
);
